module.exports = __webpack_public_path__ + "img/finalImage.191d6a59.png";